import { render, staticRenderFns } from "./switchWithoutLabel.vue?vue&type=template&id=00807b30&scoped=true"
import script from "./switchWithoutLabel.vue?vue&type=script&lang=js"
export * from "./switchWithoutLabel.vue?vue&type=script&lang=js"
import style0 from "./switchWithoutLabel.vue?vue&type=style&index=0&id=00807b30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00807b30",
  null
  
)

export default component.exports